import { apiBackofficeReportsMs } from "../api-backoffice-reports-ms";
import { z } from "zod";
import { apiWobaBackend } from "../api-woba-backend";

const searchCompaniesResponseSchema = z.array(
  z.object({
    id: z.number(),
    name: z.string(),
  }),
);

const companyPackagesResponseSchema = z.array(
  z.object({
    id: z.number(),
    name: z.string(),
    products: z.array(z.string()),
    versions: z.array(
      z.object({
        id: z.number(),
        status: z.string(),
      }),
    ),
  }),
);

export const companyService = {
  async searchCompanies({
    term,
  }: {
    term: string;
  }): Promise<z.infer<typeof searchCompaniesResponseSchema>> {
    try {
      const searchParams = new URLSearchParams();
      if (term) {
        searchParams.append("term", term);
      }
      const response = await apiBackofficeReportsMs.get(
        `/companies?${searchParams}`,
      );

      const parsedData = searchCompaniesResponseSchema.parse(response.data);

      return parsedData;
    } catch (error) {
      //TODO: Implement error tracking
      console.error(error);
      return [];
    }
  },
  async getCompanyPackages({
    companyId,
    take = 10,
  }: {
    companyId: number;
    take?: number;
  }): Promise<z.infer<typeof companyPackagesResponseSchema>> {
    try {
      const response = await apiWobaBackend.get(
        `/companies/${companyId}/packages?take=${take}`,
      );

      if (!response.data) {
        return [];
      }

      const parsedPackages = response.data.data.map(
        (item: {
          id: number;
          products: string[];
          versions: { id: number; status: string }[];
        }) => {
          return {
            id: item.id,
            name: `Pacote ID = ${item.id}`,
            products: item.products,
            versions: item.versions,
          };
        },
      );

      const parsedData = companyPackagesResponseSchema.parse(parsedPackages);

      return parsedData;
    } catch (error) {
      //TODO: Implement error tracking
      console.error(error);
      return [];
    }
  },
};
